export const HASURA_SERVER = process.env.REACT_APP_HASURA_SERVER;
export const HASURA_QUERY_ENDPOINT = HASURA_SERVER + 'v1/graphql';

export const SENTRY_DNS = process.env.REACT_APP_SENTRY_DNS || null;

export const ANONYMOUS_JSON_WEB_TOKEN = process.env.REACT_APP_ANONYMOUS_JSON_WEB_TOKEN;

export const LANGUAGES = [
  {
    code: 'en',
    sourceSuffix: '',
    label: 'EN',
    keepRequired: true,
  },
  {
    code: 'pt',
    sourceSuffix: '_pt',
    label: 'PT',
    keepRequired: false,
  },
];

// TODO FIXME this is a hack! If the database starts having too much data,
// 5000 might not be enough anymore, but increasing this value will impact performance
// eventually, we just need to make better queries.
export const QUERY_PER_PAGE = 5000;

// Limit for fetching existing associations (many-to-many relationships)
export const QUERY_ASSOCIATIONS_PER_PAGE = 300;
